import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PromoBanner from '../components/PromoBanner';
import { Download, CheckCircle } from 'lucide-react';

const SARoadmapDownloadPage = () => {
  // Mark as unlocked when user lands here (they came from Beehiiv)
  useEffect(() => {
    localStorage.setItem('saRoadmapUnlocked', 'true');
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <PromoBanner />
      <Navigation />
      
      {/* Download Section */}
      <section className="pt-24 pb-20 bg-gradient-to-br from-green-50 to-emerald-100 min-h-[80vh] flex items-center">
        <div className="container">
          <div className="max-w-2xl mx-auto text-center">
            <div className="bg-white rounded-2xl shadow-xl p-10">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
                <CheckCircle className="text-green-600" size={40} />
              </div>
              
              <h1 className="text-3xl font-bold text-gray-900 mb-4">
                🎉 You're In!
              </h1>
              
              <p className="text-lg text-gray-600 mb-8">
                Thanks for subscribing! Your 90-Day Solutions Architect Checklist is ready to download.
              </p>
              
              <a
                href="/90-Day-Solutions-Architect-Roadmap.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-gradient-to-r from-sky-500 to-blue-600 text-white px-10 py-5 rounded-xl font-semibold text-xl hover:shadow-lg transition-all duration-200"
              >
                <Download size={28} />
                Download Your Checklist
              </a>
              
              <p className="text-sm text-gray-500 mt-6">
                📧 Check your inbox for weekly cloud tips!
              </p>
              
              <div className="mt-8 pt-6 border-t border-gray-200">
                <p className="text-gray-600 mb-4">Ready to start learning?</p>
                <a
                  href="/learning-paths/solutions-architect"
                  className="text-blue-600 hover:text-blue-700 font-medium"
                >
                  Explore Solutions Architect Learning Path →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SARoadmapDownloadPage;
